import React, { FunctionComponent } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useRecoilValue } from 'recoil';

import { submitAuth } from '@constants/state';

const SubmitAuth: FunctionComponent = () => {
  const { isLogin } = useRecoilValue(submitAuth);
  const location = useLocation();

  return (
    <>
      {isLogin ? (
        <Outlet />
      ) : (
        <Navigate to="/submit" state={{ from: location }} replace />
      )}
    </>
  );
};

export default SubmitAuth;
